module.exports = new __parcel__URL__("cornershop-shopper-android.bb6af1c5.png").toString();